import { defineStore } from "pinia";

export const tokenStore = defineStore("user", {
  state: () => ({
    token: "",
    userInfo: {},
  }),
  getters: {
    getToken: (state) => state.token,
    getUserInfo: (state) => {
      if (JSON.stringify(state.userInfo) === "{}") {
        const info = localStorage.getItem("userInfo");
        return JSON.parse(info);
      } else {
        return state.userInfo;
      }
    },
  },
  actions: {
    setToken(token) {
      this.token = token;
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo;
    },
  },
});
